import styled from 'styled-components';
import { createGlobalStyle } from 'styled-components';

export const CustomSignature = styled.div`
  background: white;
  max-width: 453px;
  margin: 0 auto;
  min-height: 500px;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 12px 12px 0;

  @media all and (max-width: 600px) {
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const Content = styled.div`
  /*quiero que el height sea el 100% del padre*/
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media all and (max-width: 600px) {
    height: 100%;
  }

  @media all and (max-width: 500px) {
    height: 100%;
  }
`;
export const CustomTop = styled.div`
 /*  margin-top: 50px;

  @media all and (max-width: 600px) {
    margin-top: 0px;

  } */
`;

export const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
     font-family: 'Factor A', 'DM Sans', sans-serif;
  }

  body {
    font-family: 'Factor A', 'DM Sans', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    justify-content: center;
    background: lightgray;
    display: initial;
  }

  @media all and (max-width: 600px) {
    body {
      background: white;
      justify-content: center;
      
    }
  }
`;

export const SignatureContainer = styled.div``;